import DownloadApp from "../components/DownloadApp";
import PricingSection from "../components/PageSections/Pricing/PricingSection";


const PricingPage = () => {
    return (
        <main>
            <PricingSection />            
            <DownloadApp />
        </main>
    );
};

export default PricingPage;
